import { useMissionsUrl } from '@/features/missions/context/MissionsUrlProvider'
import { Button, Text } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import { useNavigate } from 'react-router-dom'
import type { NectarProject } from '../api/models'
import { isProlificMode } from '../prolific/session'
import { LinkedMissions } from './LinkedMissions'
import { MissionProjectHeader } from './MissionProjectHeader'

type NectarTaskExpiredProps = {
  project: NectarProject
}

export const NectarTaskExpired = ({ project }: NectarTaskExpiredProps) => {
  const { missionsUrl } = useMissionsUrl()
  const navigate = useNavigate()
  const prolificMode = isProlificMode()

  return (
    <>
      <MissionProjectHeader project={project} />
      <div className="max-mobile:max-w-[320px] max-mobile:px-2 mx-auto mt-10 flex w-full max-w-[864px] flex-col items-center gap-4 rounded-2xl border border-solid border-gray-100 px-10 py-12 text-center">
        <Text type="h5" className="text-gray-70">
          <Trans>Mission Expired</Trans>
        </Text>
        <Text type="body2-regular" className="text-gray-80">
          <Trans>The time window for this mission has ended. You can no longer start or submit this assessment.</Trans>
        </Text>
        {!prolificMode && (
          <Button size="small" onClick={() => navigate(missionsUrl)} className="mt-2">
            <Trans>Back to Missions</Trans>
          </Button>
        )}
        {!prolificMode && <LinkedMissions projectId={project.id} />}
      </div>
    </>
  )
}
